<template>
	<div class="wrap-loader">
		<span class="loader">
			<svg width="86" height="81" viewBox="0 0 86 81" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M34.4306 51.3207C24.7067 51.3207 16.868 43.5834 16.868 33.9853C16.868 24.3871 24.7067 16.6498 34.4306 16.6498C44.1546 16.6498 51.9933 24.3871 51.9933 33.9853C51.9933 43.5834 44.1546 51.3207 34.4306 51.3207ZM70.2504 34.2791V2.74233H53.3824V5.58259C47.9251 2.05675 41.4755 0 34.4306 0C15.3797 0 0 15.1807 0 33.9853C0 52.7898 15.3797 67.9705 34.4306 67.9705C43.7577 67.9705 52.1917 64.2488 58.4428 58.3724C62.1141 66.7952 67.7698 74.4346 75.0132 80.8048L85.9278 67.9705C75.9062 59.4497 70.2504 47.2072 70.2504 34.2791Z"
					fill="black"
				/>
			</svg>
		</span>
	</div>
</template>
<script lang="ts">
import Vue from "vue";

export default Vue.extend({
	name: "Loading"
});
</script>
<style scoped>
.wrap-loader {
	text-align: center;
	width: 5rem;
	height: 5rem;
	margin: 0 auto;
	border-radius: 50%;
	-webkit-animation: pulse-wrapper 3s infinite ease;
	animation: pulse-wrapper 3s infinite ease;
}
.loader {
	display: inline-block;
	width: 3.5rem;
	height: 3.5rem;
	top: 15%;
	position: relative;
}
.loader svg {
	display: inline-block;
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
}

.loader svg * {
	-webkit-animation: pulse-logo 3s infinite ease forwards;
	animation: pulse-logo 3s infinite ease forwards;
}

@-webkit-keyframes pulse-logo {
	0% {
		fill: black;
	}
	40% {
		fill: white;
	}
	70% {
		fill: white;
	}
	100% {
		fill: black;
	}
}
@keyframes pulse-logo {
	0% {
		fill: black;
	}
	40% {
		fill: white;
	}
	70% {
		fill: white;
	}
	100% {
		fill: black;
	}
}

@-webkit-keyframes pulse-wrapper {
	0% {
		transform: scale(1, 1);
		background-color: transparent;
	}
	40% {
		transform: scale(1.5, 1.5);
		background-color: var(--adm-pink);
	}
	60% {
		transform: scale(1.5, 1.5);
		background-color: var(--adm-pink);
	}
	100% {
		transform: scale(1, 1);
		background-color: transparent;
	}
}
@keyframes pulse-wrapper {
	0% {
		transform: scale(1, 1);
		background-color: transparent;
	}
	40% {
		transform: scale(1.5, 1.5);
		background-color: var(--adm-pink);
	}
	60% {
		transform: scale(1.5, 1.5);
		background-color: var(--adm-pink);
	}
	100% {
		transform: scale(1, 1);
		background-color: transparent;
	}
}
</style>
